import { message } from "antd";
import InternalApi from "../axios/internalApi";

export const getOrderDetails = async ({
  pageNumber = 1,
  itemPerPage = 4,
  text,
  filterBy = ""
}) => {
  try {
    console.log()
    return await InternalApi.get({
      server: "api/v1/",
      path: `admin/order-details?pageNumber=${
        text ? 1 : pageNumber
      }&itemPerPage=${itemPerPage}${text ? `&text=${text}` : ""}${filterBy ? `&filter=${filterBy}` : ""}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getOrderDetailsById = async (id) => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `admin/order-by-id/${id}`,
    });
  } catch (error) {
    //message.error(error?.data?.message);
  }
};

export const refundPaymentOrder = async ({ paymentId, orderId }) => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `admin/payments/refund?paymentIntentId=${paymentId}&orderId=${orderId}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const deleteOrder = async (id) => {
  try {
    return await InternalApi.delete({
      server: "api/v1/",
      path: `admin/delete-order/${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
